// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2g0uN","signatureBlock":"Footer_signatureBlock__2n-4Q","signature":"Footer_signature__36IgD"};